<ngb-alert
	type="danger"
	class="alert-dismissible alert-solid alert-label-icon fade show custom-alert"
>
	<i class="ri-error-warning-line label-icon"></i>{{ message }}
</ngb-alert>
